import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { uiLocaleSelector } from '../../redux/ui/selectors';

const LanguageProvider = ({ locale, messages, children }) => (
  <IntlProvider locale={locale} key={locale} messages={messages[locale]}>
    {React.Children.only(children)}
  </IntlProvider>
);

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = state => ({
  locale: uiLocaleSelector(state),
});

export default connect(mapStateToProps)(LanguageProvider);



// WEBPACK FOOTER //
// ./src/components/LanguageProvider/index.jsx